<div class="total-amount">
   {{title || 'Total Amount:'}}
  <b>{{ totalAmount }}</b>
</div>
